module.exports = __webpack_public_path__ + "static/media/chimney.842ce2a4.svg";